// Common SVGs (used in both regions)
const commonIcons = {
    // bgIcon: `
    //     <g opacity="0.06">
    //         <path fill-rule="evenodd" clip-rule="evenodd" d="M88.4392 72.0617V13.1024H68.7859V91.7154H117.918V72.0617H88.4392Z" fill="#0B359A"/>
    //         <path fill-rule="evenodd" clip-rule="evenodd" d="M19.6531 78.6124C19.6531 46.0501 46.0501 19.6531 78.6123 19.6531C111.175 19.6531 137.571 46.0501 137.571 78.6124C137.571 111.175 111.175 137.571 78.6123 137.571C46.0501 137.571 19.6531 111.175 19.6531 78.6124ZM0 78.6124C0 35.1959 35.196 0 78.6123 0C122.029 0 157.225 35.1959 157.225 78.6124C157.225 96.7792 151.062 113.506 140.714 126.817L174 160.103L160.103 174L126.818 140.714C113.506 151.062 96.7791 157.225 78.6123 157.225C35.1959 157.225 0 122.029 0 78.6124Z" fill="#0B359A"/>
    //     </g>
    // `,
    // Other common icons...
};

// US-specific SVGs
const usIcons = {
    ...commonIcons, // Include common icons
    bgIcon: `
        <g opacity="0.06">
<path d="M104.411 0C87.0899 0 72.7728 12.6624 70.0748 29.2278H70.4705C72.8627 21.6556 79.8954 16.1338 88.259 16.1338C98.5113 16.1338 106.965 24.2096 106.965 34.5878V69.949H139.25V34.5878C139.107 15.4683 123.566 0 104.411 0Z" fill="#003865"/>
<path d="M69.5713 174C86.8922 174 101.209 161.338 103.907 144.772H103.512C101.119 152.344 94.0868 157.866 85.7231 157.866C75.4709 157.866 67.0173 149.79 67.0173 139.412V104.051H34.7318V139.412C34.8756 158.532 50.4159 174 69.5713 174Z" fill="#003865"/>
<path d="M174 104.41C174 87.0886 161.337 72.7715 144.772 70.0735V70.4692C152.344 72.8614 157.866 79.8941 157.866 88.2578C157.866 98.51 149.79 106.964 139.412 106.964H104.051V139.249H139.412C158.532 139.105 174 123.565 174 104.41Z" fill="#003865"/>
<path d="M0 69.5697C0 86.8906 12.6624 101.208 29.2278 103.906V103.51C21.6556 101.118 16.1338 94.0851 16.1338 85.7215C16.1338 75.4693 24.2096 67.0157 34.5878 67.0157H69.949V34.7301H34.5878C15.4683 34.874 0 50.4142 0 69.5697Z" fill="#003865"/>
</g>
    `,
    brandIcon: `<path d="M19.202 0C16.0166 0 13.3835 2.32872 12.8873 5.37524H12.9601C13.4001 3.98264 14.6934 2.96713 16.2316 2.96713C18.117 2.96713 19.6717 4.45235 19.6717 6.36097V12.8642H25.6093V6.36097C25.5828 2.84474 22.7249 0 19.202 0Z" fill="#003865"/>
<path d="M12.7947 32C15.9802 32 18.6132 29.6713 19.1094 26.6248H19.0366C18.5967 28.0174 17.3033 29.0329 15.7652 29.0329C13.8797 29.0329 12.325 27.5477 12.325 25.639V19.1358H6.38746V25.639C6.41392 29.1553 9.27189 32 12.7947 32Z" fill="#003865"/>
<path d="M32 19.2018C32 16.0163 29.6713 13.3833 26.6248 12.8871V12.9599C28.0174 13.3998 29.0329 14.6932 29.0329 16.2313C29.0329 18.1168 27.5477 19.6715 25.639 19.6715H19.1358V25.609H25.639C29.1553 25.5826 32 22.7246 32 19.2018Z" fill="#00B2E2"/>
<path d="M0 12.7944C0 15.9799 2.32872 18.6129 5.37524 19.1091V19.0363C3.98264 18.5964 2.96713 17.303 2.96713 15.7649C2.96713 13.8794 4.45235 12.3247 6.36097 12.3247H12.8642V6.38715H6.36097C2.84474 6.41361 0 9.27159 0 12.7944Z" fill="#00B2E2"/>`,
};

// AU-specific SVGs
const auIcons = {
    ...commonIcons, // Include common icons
    bgIcon: `
        <g opacity="0.06">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M88.4392 72.0617V13.1024H68.7859V91.7154H117.918V72.0617H88.4392Z" fill="#0B359A"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.6531 78.6124C19.6531 46.0501 46.0501 19.6531 78.6123 19.6531C111.175 19.6531 137.571 46.0501 137.571 78.6124C137.571 111.175 111.175 137.571 78.6123 137.571C46.0501 137.571 19.6531 111.175 19.6531 78.6124ZM0 78.6124C0 35.1959 35.196 0 78.6123 0C122.029 0 157.225 35.1959 157.225 78.6124C157.225 96.7792 151.062 113.506 140.714 126.817L174 160.103L160.103 174L126.818 140.714C113.506 151.062 96.7791 157.225 78.6123 157.225C35.1959 157.225 0 122.029 0 78.6124Z" fill="#0B359A"/>
        </g>
    `,
    brandIcon: `
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M16.2645 13.2528V2.40967H12.6501V16.8672H21.686V13.2528H16.2645Z"
            style="fill: rgb(var(--locumate-clr-logo));" />
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M3.61435 14.4574C3.61435 8.46897 8.46897 3.61435 14.4574 3.61435C20.4459 3.61435 25.3005 8.46897 25.3005 14.4574C25.3005 20.446 20.4459 25.3005 14.4574 25.3005C8.46897 25.3005 3.61435 20.446 3.61435 14.4574ZM0 14.4574C0 6.47281 6.47283 0 14.4574 0C22.442 0 28.9149 6.47281 28.9149 14.4574C28.9149 17.7985 27.7816 20.8746 25.8785 23.3227L32 29.4442L29.4442 32L23.3229 25.8785C20.8746 27.7816 17.7984 28.9149 14.4574 28.9149C6.47281 28.9149 0 22.4421 0 14.4574Z"
            style="fill: rgb(var(--locumate-clr-logo-dark));" />
    `,
    
};

// Determine the region based on the environment variable
const region = process.env.VUE_APP_REGION;

// Export the appropriate set of icons based on the region
let icons;

if (region === 'US') {
    icons = usIcons;
} else if (region === 'AU') {
    icons = auIcons;
} else {
    // Fallback or default region
    icons = commonIcons;
}

export default icons;

